<template>
    <div class="fixed bottom-4 right-4 z-50 flex flex-col-reverse gap-4">
      <toast
        v-for="(toast, index) in toasts"
        :key="index"
        :message="toast.message"
        :type="toast.type"
        :duration="toast.duration"
        @close="removeToast(index)"
      />
    </div>
  </template>
  
  <script setup lang="ts">
  import Toast from './toast.vue';
  import { useToast } from '~/composables/useToast';
  
  const { toasts, removeToast } = useToast();
  </script>